import React, { useContext, useEffect, useState } from "react";
import { GoalCategoryDropDown } from "./GoalCategoryDropdown";
import { GoalsTable } from "./GoalsTable";

import { ErrorMessage, TextBlock } from "../common/components/generalUtilities";
import { GoalHomePagePropsShape } from "../interfaces/componentTypes";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { pageListeners } from "../../utils/listeners";
import { useStatus } from "../../utils/custom_hooks/UseStatus";

const GoalHomepage: React.FC<GoalHomePagePropsShape> = ({
  setNavPage,
  profileInterviews,
  uploadFail,
  templateSet,
}) => {
  const { DBObject, t } = useContext(TMDataContext);
  const [errorFound, setErrorFound] = useState<number[]>([]);

  const [pageStatus, setPageStatus] = useStatus({
    loading: false,
    loadFail: false,
    noTemplates: false,
  });

  useEffect(() => {
    pageListeners.restoreControls();
  }, []);

  const checkErrors = () => {
    if (!templateSet || !profileInterviews) return;

    var foundErrors = [];
    templateSet.forEach((goal) => {
      goal.checkForEditorErrors(profileInterviews);
      if (goal.hasErrors) {
        foundErrors.push(goal.id);
      }
    });
    setErrorFound(foundErrors);
  };

  useEffect(() => {
    checkErrors();
  }, [profileInterviews, templateSet]);

  useEffect(() => {
    if (!templateSet || templateSet.length == 0) {
      setPageStatus("noTemplates", true);
    } else {
      setPageStatus("noTemplates", false);
    }
  }, [templateSet]);

  const displayHomepagePrompt = () => {
    if (errorFound.length > 0)
      return (
        <ErrorMessage
          message={t("views.goals.errors.program_editor_interview_mismatch")}
        />
      );
    return (
      <p className="goal-prompt">
        {t("views.goals.navigation.category_prompt")}
      </p>
    );
  };

  const displayDropdown = () => {
    if (!!DBObject) return <GoalCategoryDropDown handleSelect={setNavPage} />;
  };

  const displayHomepageContents = () => {
    if (pageStatus.loading)
      return (
        <TextBlock block={t("views.goals.navigation.loading_goal_templates")} />
      );

    if (uploadFail) {
      if (pageStatus.loadFail) {
        return (
          <TextBlock
            block={t("views.goals.errors.save_and_load_templates_failure")}
          />
        );
      } else {
        return (
          <TextBlock block={t("views.goals.errors.save_template_failure")} />
        );
      }
    }

    if (pageStatus.loadFail)
      return (
        <TextBlock block={t("views.goals.errors.load_templates_failure")} />
      );

    if (pageStatus.noTemplates)
      return <TextBlock block={t("views.goals.navigation.empty_index")} />;

    return <GoalsTable templateSet={templateSet} />;
  };

  return (
    <div className="goal-container">
      {displayHomepagePrompt()}
      <div className="goal-category-select">
        {displayDropdown()}
        <div>{displayHomepageContents()}</div>
      </div>
    </div>
  );
};
export default GoalHomepage;
